export default {"src":"/_next/static/media/PhoneLight.2298cf84.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};